<div class="modal-header">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
			<i class="material-icons">close</i>
		</button>
</div>
<div class="modal-body">
  <p [innerHTML]="message" class="text-break"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="close()">{{ noButtonText | phxTranslate }}</button>
  <button type="button" class="btn btn-primary" (click)="yes()">{{ yesButtonText | phxTranslate }}</button>
</div>